const fr = {
  app: {
    tagline: 'Le jeu de lettres qui parle plusieurs langues.',
  },
  nav: {
    back: 'Retour',
    home: 'Accueil',
    rules: 'Règles',
    settings: 'Réglages',
    about: 'À propos',
    account: 'Compte',
    leaderboards: 'Classements',
    tournaments: 'Tournois',
    daily: 'Défi du jour',
    admin: 'Administration',
  },
  common: {
    cancel: 'Annuler',
    confirm: 'Confirmer',
    close: 'Fermer',
    save: 'Enregistrer',
    loading: 'Chargement…',
    yes: 'Oui',
    no: 'Non',
    copy: 'Copier',
    copied: 'Copié !',
    retry: 'Réessayer',
  },
  langNames: {
    fr: 'français',
    en: 'anglais',
    es: 'espagnol',
    de: 'allemand',
    it: 'italien',
    pt: 'portugais',
  },
  home: {
    quickPlay: 'Jouer',
    quickPlayDesc: 'Partie Classique de 2 minutes · {{lang}}',
    modesTitle: 'Modes de jeu',
    newGame: 'Nouvelle partie',
    online: 'Jouer en ligne',
  },
  modes: {
    classic: {
      name: 'Classique',
      short: 'Une langue · 2 min',
      desc: 'Une seule langue, la même pour tous. Marquez un maximum de points en 120 secondes. Aucun bonus de langue ni de fin anticipée.',
    },
    polyglot: {
      name: 'Polyglotte commun',
      short: '2 ou 3 langues pour tous · 2 min',
      desc: 'Les mêmes 2 ou 3 langues pour tous. Bonus de diversité (+20 % à deux langues, +30 % à trois) si vous trouvez au moins 3 mots dans chaque langue.',
    },
    duel: {
      name: 'Duel tactique',
      short: '10 mots ou 2 min · contrat',
      desc: 'Chacun choisit en secret 1, 2 ou 3 langues. Objectif : 10 mots valides. Contrat linguistique + bonus de vitesse si vous atteignez les 10 mots avant la fin. Le 10e mot termine votre manche.',
    },
    sprint: {
      name: 'Sprint libre',
      short: '1 à 3 langues · 2 min · contrat',
      desc: 'Choix individuel de 1 à 3 langues, maximum de points en 120 secondes avec contrat linguistique. Aucun bonus pour finir plus tôt.',
    },
    relax: {
      name: 'Détente',
      short: 'Sans chrono',
      desc: 'Sans limite de temps et sans classement. Les indices de validité peuvent être activés dans ce mode uniquement.',
    },
  },
  setup: {
    title: 'Nouvelle partie',
    mode: 'Mode',
    languagesShared: 'Langues de la partie ({{min}} à {{max}})',
    languagesIndividual: 'Vos langues (1 à 3, choix verrouillé avant le tirage)',
    errors: {
      duplicate_language: 'Chaque langue ne peut être choisie qu’une fois.',
      too_few_languages: 'Choisissez au moins {{min}} langue(s).',
      too_many_languages: 'Au maximum {{max}} langue(s).',
    },
    noLanguageBonus: 'Pas de bonus de langue dans ce mode.',
    opponent: 'Adversaire',
    noOpponent: 'Aucun (solo)',
    robotNotice:
      'Les robots sont des programmes d’entraînement, clairement identifiés. Ils ne comptent jamais dans les classements.',
    robotSameLanguages: 'Le robot joue avec les mêmes langues que moi',
    robotLanguages: 'Langues du robot',
    loading: 'Préparation du tirage…',
    start: 'Commencer',
    noDraw:
      'Aucun tirage équilibré n’a été trouvé pour cette combinaison. Essayez d’autres langues ou le contrat Spécialiste.',
  },
  contracts: {
    specialist: {
      name: 'Spécialiste',
      desc: 'une seule langue, bonus acquis sur vos points de base.',
    },
    duo: {
      name: 'Duo',
      desc: 'deux langues, bonus seulement avec au moins 3 mots distincts dans chacune.',
    },
    trio: {
      name: 'Trio',
      desc: 'trois langues, bonus seulement avec au moins 3 mots distincts dans chacune.',
    },
    diversity: {
      name: 'Diversité',
      desc: 'bonus de {{pct}} % pour tous si au moins 3 mots par langue.',
    },
    short: { specialist: 'Spécialiste', duo: 'Duo', trio: 'Trio', diversity: 'Diversité' },
  },
  bots: {
    rookie: 'Débutant',
    casual: 'Intermédiaire',
    skilled: 'Confirmé',
    expert: 'Expert',
    rookieDesc: 'Mots très courants, rythme lent, préfère les mots courts.',
    casualDesc: 'Mots courants, rythme modéré.',
    skilledDesc: 'Vocabulaire courant étendu, rythme soutenu.',
    expertDesc: 'Connaît aussi des mots rares, rapide, vise les mots longs.',
    robotName: 'Robot {{level}}',
  },
  game: {
    timeLeft: 'Temps restant',
    getReady: 'Prêt…',
    untimed: '∞',
    score: 'Score',
    points: 'pts',
    wordsOfTarget: '{{n}} / {{target}} mots',
    wordsCount_one: '{{count}} mot',
    wordsCount_other: '{{count}} mots',
    languageCounters: 'Mots par langue',
    robotNotice: 'Adversaire robot (programme d’entraînement)',
    opponentDone: 'terminé',
    finalWarning:
      'Attention : votre prochain mot valide sera le 10e et terminera la manche. Votre contrat n’est pas encore rempli.',
    currentWord: 'Mot en cours',
    tapLetters: 'Touchez les lettres',
    hintValid: 'Valide : {{langs}}',
    hintInvalid: 'Pas (encore) un mot',
    attributeTo: 'Attribuer à {{lang}}',
    attribution: 'Langue :',
    auto: 'Auto',
    autoExplain:
      'Auto : le mot est attribué à la langue valide qui a le plus besoin de mots pour votre contrat, sinon selon l’ordre de vos langues.',
    rack: 'Lettres du tirage',
    tileLabel: 'Lettre {{letter}}, position {{pos}}',
    shuffle: 'Mélanger',
    delete: 'Effacer',
    clear: 'Vider',
    submit: 'Valider',
    foundWords: 'Mots trouvés',
    bonusSecured: 'bonus de langue acquis',
    finish: 'Terminer',
    stop: 'Arrêter',
    stopTitle: 'Arrêter la manche ?',
    stopBody: 'Vos mots sont conservés. Arrêter plus tôt ne donne aucun bonus.',
    finishBody: 'Terminer la partie détente et voir le bilan ?',
    confirmFinalTitle: 'Dernier mot : contrat non rempli',
    confirmFinalOk: 'Valider quand même',
    confirmFinalBody:
      'Ce 10e mot termine immédiatement votre manche. Votre contrat linguistique ne sera pas rempli : pas de bonus de langue (le bonus de vitesse reste acquis).',
    accepted: '« {{word}} » +{{points}} ({{lang}})',
  },
  reasons: {
    round_over: 'La manche est terminée.',
    invalid_characters: 'Caractères non jouables.',
    too_short: 'Trois lettres minimum.',
    too_long: 'Mot trop long.',
    not_formable: 'Impossible avec ces lettres.',
    duplicate: 'Déjà trouvé.',
    language_not_allowed: 'Langue non autorisée dans cette manche.',
    excluded_word: 'Mot exclu par la politique de contenu du jeu.',
    not_a_word: 'Mot inconnu dans vos langues.',
    wrong_language: 'Ce mot est valide en : {{langs}}.',
    confirmation_required: 'Confirmation nécessaire.',
    rate_limited: 'Trop de tentatives, ralentissez.',
    not_started: 'La manche n’a pas encore commencé.',
  },
  results: {
    points: 'points',
    pts: 'pts',
    base: 'Points de base',
    fulfilled: 'rempli',
    missed: 'manqué',
    speedBonus: 'Bonus de vitesse',
    officialTime: 'Temps officiel',
    target: 'Objectif',
    endReason: {
      target_reached: 'Objectif atteint',
      time_up: 'Temps écoulé',
      stopped: 'Arrêt volontaire',
      abandoned: 'Abandon',
    },
    explainBase: 'Vos mots rapportent {{base}} points de base (10 × (lettres − 2)).',
    explainSpecialist: 'Contrat Spécialiste : +10 % acquis.',
    explainQuotaOk: 'Au moins {{quota}} mots dans chaque langue : bonus de {{pct}} % acquis.',
    explainQuotaKo:
      'Il fallait au moins {{quota}} mots dans chaque langue : pas de bonus de langue ({{pct}} % possibles).',
    explainSpeedOk: '10 mots atteints en {{time}} : bonus de vitesse de {{pct}} %.',
    explainSpeedKo: 'Objectif de 10 mots non atteint avant la fin : pas de bonus de vitesse.',
    explainFormula:
      'Total = base × (1 + bonus de langue + bonus de vitesse), arrondi une seule fois au centième.',
    win: 'Victoire !',
    lose: 'Défaite',
    tie: 'Égalité',
    tieExplain: 'Scores exactement identiques : la rencontre est déclarée à égalité.',
    you: 'Vous',
    robotTitle: '{{name}} (robot)',
    missedWords: 'Mots courants que vous pouviez former',
    missedWordsNote: 'Liste indicative de mots fréquents de vos langues, pour la prochaine fois.',
    shareText: '{{mode}} ({{langs}}) : {{score}} points, {{words}} mots. Qui fait mieux ?',
    playAgain: 'Rejouer',
    share: 'Partager le résultat',
    changeSetup: 'Changer de mode',
    localNotice: 'Partie locale : n’entre dans aucun classement.',
    savedToHistory: 'Enregistrée dans « Mes parties » (entraînement).',
    drawAudit: 'Tirage {{seed}} ({{gen}})',
  },
  errors: {
    network: 'Connexion perdue. Nouvel essai…',
    lexiconLoad: 'Impossible de charger le dictionnaire. Vérifiez la connexion et réessayez.',
    notFound: 'Page introuvable',
    generic: 'Une erreur est survenue.',
  },
  online: {
    title: 'En ligne',
    challengeFriend: 'Défier un ami',
    challengeFriendDesc: 'Lien d’invitation, chacun joue quand il veut',
    liveDuel: 'Duel en direct',
    liveDuelDesc: 'Salon, invitation, partie simultanée',
    myGames: 'Mes parties',
    offlineNote: 'Serveur injoignable : seuls le solo et l’entraînement sont disponibles.',
    guestBanner:
      'Vous jouez en invité. Créez un compte pour sauvegarder votre historique et rejoindre les classements.',
    saveAccount: 'Sauvegarder mon compte',
  },
  challenge: {
    newTitle: 'Défier un ami',
    returnMatch: 'Rencontre aller-retour (2 manches, tirages croisés, non classée)',
    create: 'Créer le défi',
    created: 'Défi créé ! Envoyez ce lien :',
    share: 'Partager le lien',
    shareText: 'Je te défie ({{mode}}) !',
    expires: 'Expire le {{date}}',
    playMine: 'Jouer ma manche maintenant',
    inviteFrom: '{{name}} vous défie !',
    acceptTitle: 'Invitation',
    chooseLanguages: 'Choisissez vos langues (verrouillées après validation)',
    compatibleOnly: 'Seules les combinaisons compatibles avec le tirage de ce défi sont proposées.',
    accept: 'Accepter le défi',
    expired: 'Ce défi a expiré.',
    taken: 'Ce défi a déjà été accepté par quelqu’un d’autre.',
    own: 'C’est votre propre défi : partagez le lien avec un ami.',
    notFound: 'Défi introuvable.',
    returnInfo:
      'Rencontre aller-retour : deux manches sur deux tirages différents ; aucun résultat n’est révélé avant la fin.',
    goToMatch: 'Aller à la partie',
  },
  match: {
    readyTitle: 'Votre manche',
    readyBody:
      'Le chronomètre démarre dès que les lettres apparaissent. Fermer ou recharger la page ne remet pas le temps à zéro.',
    start: 'Commencer ma manche',
    waitingOpponent:
      'En attente de l’adversaire. Ses mots et son score restent cachés jusqu’à la fin.',
    opponentProgress: '{{name}} : {{count}} mot(s)',
    leg: 'Manche {{n}} / 2',
    nextLeg: 'Jouer la manche suivante',
    encounterTotal: 'Total de la rencontre',
    unranked: 'Partie non classée',
    ranked: 'Partie classée',
    reportWord: 'Signaler un mot refusé',
    reportPrompt: 'Mot à signaler (et langue)',
    reportSent: 'Merci, signalement envoyé.',
    loadError: 'Impossible de charger la partie.',
    opponentNotPlayed: 'L’adversaire n’a pas joué.',
    opponent: 'Adversaire',
  },
  account: {
    title: 'Mon compte',
    guest: 'Compte invité',
    registered: 'Compte sauvegardé',
    register: 'Créer un compte',
    login: 'Se connecter',
    logout: 'Se déconnecter',
    username: 'Identifiant (3–20 caractères)',
    password: 'Mot de passe (10 caractères min.)',
    email: 'E-mail (facultatif)',
    displayName: 'Nom affiché',
    saveHint: 'Votre historique d’invité est conservé quand vous créez votre compte.',
    history: 'Historique',
    export: 'Exporter mes données',
    delete: 'Supprimer mon compte',
    deleteConfirm:
      'Supprimer définitivement votre compte ? Vos données personnelles seront effacées.',
    notifications: 'Rappels',
    remindersOptIn: 'Recevoir des rappels (au plus un par jour, jamais pendant les heures calmes)',
    quietHours: 'Heures calmes (de … à …)',
    haveAccount: 'Déjà un compte ?',
    noAccount: 'Pas encore de compte ?',
    saved: 'Enregistré.',
    errors: {
      invalid_credentials: 'Identifiant ou mot de passe incorrect.',
      username_or_email_taken: 'Identifiant ou e-mail déjà utilisé.',
      nickname_refused: 'Ce nom n’est pas autorisé.',
      nickname_reserved: 'Ce nom est réservé.',
      nickname_length: 'Entre 3 et 20 caractères.',
      nickname_characters: 'Caractères non autorisés.',
      invalid_request: 'Vérifiez les champs.',
      account_suspended: 'Compte suspendu.',
      generic: 'Une erreur est survenue.',
    },
  },
  live: {
    searching: 'Recherche d’un adversaire…',
    searchingBody: 'Attente : {{seconds}} s',
    noFakePlayers:
      'Seuls de vrais joueurs sont proposés ici ; aucun robot n’est présenté comme humain.',
    fallbackTitle: 'Personne pour l’instant. Vous pouvez :',
    fallbackRobot: 'Jouer contre un robot (entraînement, non classé)',
    fallbackAsync: 'Créer un défi asynchrone à partager',
    othersSearching_zero: 'Aucun autre joueur ne cherche une partie de ce type en ce moment.',
    othersSearching_one: '{{count}} autre joueur cherche une partie de ce type en ce moment.',
    othersSearching_other: '{{count}} autres joueurs cherchent une partie de ce type en ce moment.',
    noOpponentFound: 'Personne n’est disponible pour l’instant. Vous pouvez :',
    searchAgain: 'Chercher à nouveau',
    languagesSecret: 'Vos langues (secrètes, verrouillées avant le tirage)',
    quick: 'Partie rapide',
    createRoom: 'Créer un salon et inviter',
    rankedNote:
      'Les parties entre comptes sauvegardés comptent pour le classement (officiel ou expérimental selon le mode).',
    roomFull: 'Ce salon est complet.',
    roomNotFound: 'Salon introuvable ou expiré.',
    offline: 'déconnecté',
    online: 'connecté',
    opponentReady: 'prêt',
    waitingOpponent: 'En attente d’un adversaire…',
    shareRoom: 'Invitez un ami avec ce lien :',
    sharedReady: 'Langues imposées pour les deux joueurs.',
    lock: 'Je suis prêt',
    waitingLock: 'En attente du choix de l’adversaire…',
    noDrawForBoth:
      'Aucun tirage équilibré pour vos deux configurations. Choisissez d’autres langues.',
    disconnectRule:
      'Règle de déconnexion : le chronomètre du serveur continue ; revenez sur cette page pour reprendre votre manche là où elle en est.',
    opponentLeft:
      '{{name}} s’est déconnecté. Son chronomètre continue ; il peut revenir avant la fin de sa manche.',
    opponentBack: '{{name}} est de retour.',
    reconnecting:
      'Connexion interrompue, reconnexion en cours… Vos mots déjà validés sont conservés.',
    rematch: 'Revanche',
    joinRematch: 'Rejoindre la revanche',
    reactionsTitle: 'Réactions',
    reactions: {
      gg: 'Bien joué !',
      bravo: 'Bravo !',
      wow: 'Impressionnant !',
      oops: 'Oups !',
      thanks: 'Merci !',
      good_luck: 'Bonne chance !',
    },
  },
  boards: {
    title: 'Classements',
    official: 'Officiel',
    experimental: 'Expérimental',
    officialDesc: 'Modes symétriques (Classique, Polyglotte commun) : mêmes langues pour tous.',
    experimentalDesc:
      'Duel tactique et Sprint libre : classement distinct, non comparable aux modes symétriques.',
    myRank: 'Votre rang : {{rank}} · {{rating}} points Elo · {{games}} parties',
    empty: 'Aucun résultat pour l’instant.',
    player: 'Joueur',
    rating: 'Elo',
    games: 'Parties',
    rules:
      'Seules les parties entre comptes sauvegardés comptent. Robots, parties locales et rencontres aller-retour n’entrent jamais au classement.',
  },
  tournaments: {
    title: 'Tournois',
    intro:
      'Tournois hebdomadaires asynchrones : plusieurs manches, une tentative par manche, mêmes lettres pour tous.',
    none: 'Aucun tournoi pour le moment.',
    weeklyTitle: 'Hebdo {{mode}} {{langs}} · {{period}}',
    rounds: '{{n}} manche(s)',
    entrants: '{{n}} inscrit(s)',
    registered: 'inscrit',
    status: {
      scheduled: 'À venir',
      open: 'En cours',
      closing: 'Clôture',
      closed: 'Terminé',
      cancelled: 'Annulé',
    },
    frozen: 'Règles {{rules}} et dictionnaires {{lexicons}} figés pour tout le tournoi.',
    attempts: '{{n}} tentative(s) par manche.',
    sharingLimit:
      'Limite connue : dans une compétition asynchrone publique, des joueurs peuvent se communiquer les réponses. Le jeu ne prétend pas l’empêcher totalement.',
    register: 'M’inscrire',
    accountRequired: 'Un compte sauvegardé est nécessaire pour participer aux tournois.',
    myRounds: 'Mes manches',
    round: 'Manche {{n}}',
    resume: 'Reprendre',
    play: 'Jouer',
    standings: 'Classement du tournoi',
    roundsPlayed: '{{n}} manche(s)',
    tieRule: 'Égalité exacte : même rang, sans départage caché.',
    backToTournament: 'Retour au tournoi',
    finalStandings: 'Classement final',
    myResult: 'Votre total : {{total}} points · rang {{rank}} sur {{n}}',
    noRoundYet: 'Aucune manche jouée pour l’instant.',
    startsAt: 'Début : {{date}}',
    abandoned: 'Non terminée',
    retry: 'Nouvelle tentative ({{n}} restante(s))',
    closingNote:
      'Clôture en cours : les manches déjà commencées peuvent se terminer ; le classement final suit dans quelques minutes.',
    errors: {
      competition_not_found: 'Tournoi introuvable.',
      invitation_required: 'Ce tournoi est privé : une invitation est nécessaire.',
      attempts_exhausted: 'Tentative déjà utilisée pour cette manche.',
      competition_closed: 'Le tournoi est terminé.',
      competition_not_started: 'Le tournoi n’a pas commencé.',
      not_registered: 'Inscrivez-vous d’abord.',
      account_required: 'Compte sauvegardé requis.',
    },
  },
  daily: {
    title: 'Défi du jour',
    intro:
      'Un tirage par catégorie et par jour (UTC), le même pour tout le monde. Une seule tentative.',
    back: 'Retour aux défis du jour',
    play: 'Jouer',
    inProgress: 'En cours',
    resets: 'Nouveau défi le {{time}}.',
  },
  profile: {
    title: 'Mon profil',
    streak: 'jours de série',
    bestStreak: 'meilleure série',
    rounds: 'parties en ligne',
    distinctWords: 'mots différents',
    streakRules:
      'La série gagne un jour quand vous terminez une partie en ligne avec au moins un mot valide (défi du jour, défi entre amis, duel en direct ou tournoi), une fois par jour au plus. Jours de grâce gratuits restants : {{grace}} (renouvelés tous les 30 jours). Fuseau : {{tz}}.',
    useMyTimezone: 'Utiliser mon fuseau ({{tz}})',
    tzTooSoon: 'Le fuseau ne peut être modifié qu’une fois tous les 7 jours.',
    badges: 'Badges',
    noBadges: 'Pas encore de badge.',
    badgesNote: 'Les badges reposent uniquement sur des événements vérifiés par le serveur.',
    cosmetics: 'Personnalisation',
    cosmeticsNote: 'Purement visuel : aucun effet sur le score ni sur les tirages.',
    plusOnly: 'Réservé à Plus',
    earnIt: 'À débloquer en jouant',
    slot: {
      theme: 'Thème',
      avatar: 'Avatar',
      frame: 'Cadre',
    },
    history: 'Mes parties',
    gamesSummary: '{{online}} en ligne · {{practice}} entraînement(s)',
    noGames: 'Aucune partie enregistrée pour l’instant.',
    pendingSync: '{{n}} entraînement(s) en attente d’envoi (hors ligne).',
    gamesNote:
      'Les entraînements (solo, robots, détente) se jouent sur votre appareil puis s’enregistrent ici. Le serveur vérifie les mots et recalcule le score, mais ne peut pas vérifier le temps : ils ne comptent ni pour la série, ni pour les badges, ni pour les classements.',
    sourceOnline: 'En ligne',
    sourcePractice: 'Entraînement',
    waitingOpponent: 'résultat après l’adversaire',
    playDaily: 'Jouer le défi du jour',
  },
  badges: {
    first_round: 'Première manche',
    nine_letters: 'Mot de 9 lettres',
    trio_contract: 'Contrat Trio rempli',
    speed_60: '10 mots en moins de 60 s',
    words_100: '100 mots trouvés',
    words_1000: '1 000 mots trouvés',
    streak_7: 'Série de 7 jours',
    streak_30: 'Série de 30 jours',
    first_duel_win: 'Première victoire en duel',
    tournament_participant: 'Participant de tournoi',
    tournament_winner: 'Vainqueur de tournoi',
    tournament_podium: 'Podium de tournoi',
    tournament_top10: 'Top 10 de tournoi',
    daily_participant: 'Défi du jour',
    team_weekly: 'Objectif d’équipe atteint',
  },
  cosmetics: {
    theme_default: 'Classique',
    theme_ocean: 'Océan',
    theme_aurora: 'Aurore',
    theme_sakura: 'Sakura',
    theme_mono: 'Monochrome',
    avatar_letter: 'Initiale',
    avatar_owl: 'Chouette',
    avatar_fox: 'Renard',
    frame_none: 'Aucun',
    frame_team: 'Équipe',
    frame_champion: 'Champion',
  },
  reminders: {
    title: 'Rappels',
    explain:
      'Facultatifs : au plus un rappel par jour, jamais pendant vos heures calmes, et aucun si vous avez déjà joué. Désactivables à tout moment.',
    unavailable: 'Les rappels ne sont pas disponibles sur ce serveur ou cet appareil.',
    quietStart: 'Heures calmes : début',
    quietEnd: 'Heures calmes : fin',
    enable: 'Activer les rappels',
    disable: 'Désactiver',
    enabled: 'Rappels activés.',
    disabled: 'Rappels désactivés.',
    denied: 'Autorisation refusée par le navigateur.',
  },
  journal: {
    title: 'Carnet de mots',
    intro: 'Les mots que vous avez trouvés en ligne, par langue.',
    all: 'Toutes',
    search: 'Rechercher un mot',
    empty: 'Aucun mot pour l’instant.',
  },
  friends: {
    title: 'Amis',
    inbox: 'Défis reçus',
    inboxNote: 'Ouvrez le lien reçu de votre ami pour jouer.',
    invite: 'Inviter un ami',
    inviteNote:
      'Lien valable 7 jours. Pas de messagerie libre : uniquement des défis et des réactions prédéfinies.',
    none: 'Pas encore d’amis.',
    challenge: 'Défier',
    remove: 'Retirer',
    ownInvite: 'C’est votre propre invitation.',
    inviteInvalid: 'Invitation invalide ou expirée.',
  },
  team: {
    title: 'Équipe',
    intro:
      'Rejoignez ou créez une équipe (20 membres max.) et atteignez ensemble un objectif hebdomadaire de mots. Récompenses uniquement cosmétiques.',
    name: 'Nom de l’équipe',
    create: 'Créer l’équipe',
    weekly: 'Objectif de la semaine {{week}}',
    progress: '{{words}} / {{goal}} mots',
    rewardNote: 'Objectif atteint : cadre « Équipe » pour chaque membre.',
    members: 'Membres ({{n}})',
    leave: 'Quitter l’équipe',
    accountRequired: 'Un compte sauvegardé est nécessaire.',
    joinFailed: 'Impossible de rejoindre cette équipe.',
  },
  moderation: {
    block: 'Bloquer ce joueur',
    blocked: 'Joueur bloqué.',
    report: 'Signaler…',
    reported: 'Signalement envoyé.',
    reasons: {
      nickname: 'Pseudo inapproprié',
      cheating: 'Triche présumée',
      harassment: 'Harcèlement',
      other: 'Autre',
    },
  },
  plus: {
    intro: 'Plus soutient le jeu et ajoute des outils, sans jamais toucher au score :',
    fairness:
      'Le cœur du jeu, les six langues, l’entraînement, les défis et la compétition publique restent gratuits. Aucun réglage de difficulté ne dépend de l’abonnement.',
    features: {
      advanced_stats: 'Statistiques avancées',
      challenge_archives: 'Archives complètes des défis terminés',
      personal_training: 'Entraînement personnalisé déterministe',
      customisation: 'Thèmes et avatars exclusifs',
      private_tournaments: 'Outils de tournois privés',
    },
    monthly: 'S’abonner — {{price}}',
    yearly: 'Formule annuelle — {{price}}',
    unavailable: 'Plus n’est pas encore disponible au paiement.',
    testMode: 'Mode test : aucun paiement réel.',
    confirming:
      'Paiement en cours de confirmation… (validé uniquement à réception de la confirmation du prestataire)',
    cancelled: 'Paiement annulé.',
    active: 'Plus actif',
    until: 'jusqu’au {{date}}',
    manage: 'Gérer mon abonnement',
    stats: 'Statistiques',
    mode: 'Mode',
    rounds: 'Manches',
    avgScore: 'Score moyen',
    contractRate: 'Contrats remplis',
    secPerWord: 's / mot',
    train: 'Entraînement personnalisé ({{lang}})',
    archive: 'Archives des défis terminés',
    archiveEmpty: 'Aucune partie terminée pour l’instant.',
    archiveMore: 'Afficher plus',
    archiveBot: 'robot',
    pricesNote:
      'Prix indicatifs susceptibles d’évoluer ; le montant exact est affiché sur la page de paiement.',
    notOffered: 'Aucun abonnement n’est proposé dans cette version : tout le jeu est gratuit.',
  },
  legal: {
    draftBanner: 'Brouillon — à compléter avec l’identité réelle de l’éditeur.',
    privacy: 'Confidentialité',
    terms: 'Conditions',
    notice: 'Mentions légales',
  },
  offline: {
    title: 'Jouer hors ligne',
    explain:
      'Téléchargez les dictionnaires pour jouer en solo et vous entraîner sans connexion. Les parties hors ligne n’entrent dans aucun classement.',
    download: 'Télécharger',
    ready: 'Disponible',
  },
  play: { noGame: 'Aucune partie en cours.' },
  install: {
    body: 'Installer le jeu sur votre écran d’accueil pour jouer plus vite, même hors ligne en solo.',
    cta: 'Installer',
    later: 'Plus tard',
  },
  pwa: {
    updateReady: 'Une nouvelle version est prête.',
    reload: 'Mettre à jour',
    offline:
      'Hors ligne : le solo et l’entraînement restent disponibles avec les dictionnaires déjà téléchargés.',
  },
  settings: {
    title: 'Réglages',
    uiLanguage: 'Langue de l’interface',
    uiLanguageNote:
      'La langue de l’interface est indépendante des langues autorisées dans vos parties.',
    sound: 'Sons',
    haptics: 'Vibrations (si l’appareil le permet)',
    motion: 'Animations',
    motionSystem: 'Selon le système',
    motionReduced: 'Réduites',
    motionFull: 'Normales',
    relaxHints: 'Indices de validité en mode Détente',
  },
  rules: {
    title: 'Règles du jeu',
    goal: {
      title: 'But',
      body: [
        'Formez des mots avec les 9 lettres du tirage en touchant les lettres dans l’ordre voulu, sans contrainte de voisinage.',
        'Chaque tuile ne sert qu’une fois par mot ; toutes les tuiles redeviennent disponibles pour le mot suivant. Mélanger ne change pas le tirage.',
        'Trois lettres minimum. Un même mot ne rapporte qu’une fois par manche.',
      ],
    },
    tiles: {
      title: 'Lettres et accents',
      body: [
        'Les accents et la cédille n’ont pas de tuile propre : « élève » se joue E-L-E-V-E et s’affiche avec ses accents. « élève » et « élevé » sont donc le même mot jouable.',
        'Ñ (espagnol) et Ä, Ö, Ü (allemand) sont des tuiles distinctes, utilisables seulement dans leur langue. ß s’écrit avec deux S ; œ et æ utilisent deux tuiles.',
      ],
    },
    languages: {
      title: 'Langues et attribution',
      body: [
        'Un mot valide dans plusieurs de vos langues n’est attribué qu’à une seule. Choisissez la langue avant de valider (bouton Langue), ou laissez « Auto ».',
        'Auto choisit la langue valide qui a le plus besoin de mots pour votre contrat, puis l’ordre de vos langues. Une fois accepté, un mot ne change plus de langue.',
        'Noms propres et abréviations sont exclus. Certains mots offensants sont exclus par la politique de contenu. Vous pourrez signaler un mot refusé.',
      ],
    },
    points: {
      title: 'Points',
      body: [
        'Un mot de n lettres (tuiles) rapporte 10 × (n − 2) : 3 lettres = 10, 4 = 20 … 9 = 70.',
        'Score final = points de base × (1 + bonus de langue + bonus de vitesse). Les bonus s’additionnent et le total est arrondi une seule fois au centième.',
        'Un mot refusé ne rapporte rien et ne compte pas dans l’objectif.',
      ],
    },
    contracts: {
      title: 'Contrats (Duel tactique, Sprint libre)',
      body: [
        'Spécialiste (1 langue) : +10 %. Duo (2 langues) : +20 % avec au moins 3 mots dans chacune. Trio (3 langues) : +30 % avec au moins 3 mots dans chacune.',
        'Contrat manqué : vos points de base sont conservés, sans bonus de langue et sans repli vers un contrat inférieur.',
        'Polyglotte commun : +20 % (2 langues) ou +30 % (3 langues) si au moins 3 mots par langue, identique pour tous.',
      ],
    },
    speed: {
      title: 'Bonus de vitesse (Duel tactique)',
      body: [
        'Si vous atteignez 10 mots valides avant 120 s : bonus = 20 % × (120 − t) / 120, t étant le temps officiel mesuré par le serveur. À 90 s : +5 % ; à 60 s : +10 % ; à 30 s : +15 %.',
        'Le 10e mot accepté termine immédiatement votre manche. Le jeu vous prévient si votre contrat n’est pas rempli.',
      ],
    },
    modes: {
      title: 'Modes',
      body: [
        'Classique, Polyglotte commun, Duel tactique, Sprint libre, Détente (sans chrono, sans classement), et entraînement contre des robots.',
        'Égalité exacte : la rencontre est déclarée à égalité, sans prime cachée de rapidité.',
      ],
    },
    fairness: {
      title: 'Équité',
      body: [
        'Le même tirage n’a pas la même difficulté dans toutes les langues. Chaque tirage est vérifié pour offrir assez de mots courants à chaque configuration, sans garantir une équité parfaite.',
        'Les paramètres sont des hypothèses en cours de test ; une partie conserve toujours la version de règles et de dictionnaires avec laquelle elle a commencé.',
      ],
    },
    robots: {
      title: 'Robots',
      body: [
        'Les robots sont des programmes déterministes (pas d’IA générative) identifiés comme tels. Ils ne jouent que des mots valides et n’entrent jamais dans les classements humains.',
      ],
    },
    keyboard: {
      title: 'Clavier',
      body: 'Tapez les lettres (ou 1–9 pour la position d’une tuile), Entrée pour valider, Retour arrière pour effacer, Échap pour vider, Espace pour mélanger.',
    },
  },
  about: {
    title: 'À propos',
    disclaimer:
      'Un jeu de lettres pour le plaisir de jouer en plusieurs langues. Il n’a pas d’efficacité pédagogique démontrée.',
    dictionaries: 'Dictionnaires et données',
    frequencies: 'Fréquences des mots',
    policy: 'Politique de contenu',
    adapted: 'liste adaptée',
    noticeFiles:
      'Les notices complètes (sources, versions, licences) accompagnent chaque dictionnaire téléchargé.',
    noDefinitions:
      'Aucune définition ni traduction n’est affichée tant qu’une source sous licence compatible n’est pas intégrée.',
  },
};

export default fr;
export type Messages = typeof fr;
